export default __webpack_public_path__ + "static/tb_radler_04-adfae7bd75391fe0f7d283446f45b2b1.svg";